import React, { useEffect, useState } from 'react'
import { Button, Icon, Input, Modal, Radio, Slider, Spin } from 'antd'

const TimelineEditorSetupModal = ({
  visible,
  submitting,
  loading,
  onCancel,
  onSubmit
}) => {
  const [includeMusic, setIncludeMusic] = useState(false)
  const [userPrompt, setUserPrompt] = useState('')
  const [musicVolume, setMusicVolume] = useState(0.3)

  useEffect(() => {
    if (visible) {
      setIncludeMusic(false)
      setUserPrompt('')
      setMusicVolume(0.3)
    }
  }, [visible])

  return (
    <Modal
      centered
      visible={visible}
      title={loading ? 'Opening Timeline Editor' : 'Set Up Timeline Editor'}
      width={520}
      className="timeline-editor-setup-modal"
      maskClosable={false}
      destroyOnClose
      onCancel={onCancel}
      footer={
        loading
          ? undefined
          : [
              <Button key="cancel" onClick={onCancel} disabled={submitting}>
                Cancel
              </Button>,
              <Button
                key="continue"
                type="primary"
                icon="arrow-right"
                loading={submitting}
                onClick={() =>
                  onSubmit({
                    includeMusic,
                    userPrompt: userPrompt.trim(),
                    musicVolume
                  })
                }
              >
                Prepare Timeline
              </Button>
            ]
      }
    >
      {loading ? (
        <div className="timeline-editor-setup__loading">
          <Spin size="large" />
          <p>Loading video data...</p>
        </div>
      ) : (
        <div className="timeline-editor-setup">
          <div className="timeline-editor-setup__question">
            <span className="timeline-editor-setup__icon">
              <Icon type="customer-service" />
            </span>
            <div>
              <strong>Add generated background music?</strong>
              <span>The soundtrack will be placed on its own audio track.</span>
            </div>
          </div>

          <Radio.Group
            className="timeline-editor-setup__choice"
            value={includeMusic}
            onChange={event => setIncludeMusic(event.target.value)}
            buttonStyle="solid"
          >
            <Radio.Button value={false}>No music</Radio.Button>
            <Radio.Button value={true}>Generate music</Radio.Button>
          </Radio.Group>

          {includeMusic && (
            <div className="timeline-editor-setup__music-options">
              <label htmlFor="timeline-music-prompt">Music direction</label>
              <Input.TextArea
                id="timeline-music-prompt"
                value={userPrompt}
                onChange={event => setUserPrompt(event.target.value)}
                placeholder="Calm corporate, subtle build"
                autosize={{ minRows: 2, maxRows: 4 }}
                maxLength={240}
              />

              <div className="timeline-editor-setup__volume-header">
                <label>Music volume</label>
                <span>{Math.round(musicVolume * 100)}%</span>
              </div>
              <Slider
                min={0}
                max={1}
                step={0.05}
                value={musicVolume}
                tipFormatter={value => `${Math.round(value * 100)}%`}
                onChange={setMusicVolume}
              />
            </div>
          )}
        </div>
      )}
    </Modal>
  )
}

export default TimelineEditorSetupModal
